module.exports = __webpack_public_path__ + "static/media/slider-play-btn.01d657ae.svg";